import * as angularCore from "@angular/core";
import * as angularCoreRxjsInterop from "@angular/core/rxjs-interop";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

window["ng"].core = {
  ...angularCore,
};

window["ng"].core.rxjsInterop = angularCoreRxjsInterop;

export { angularCore, angularCoreRxjsInterop };
